import contentBoxFormFields from '@/components/sections/form-fields/layout/category-content-box'

export const content = {
  title: { label: 'Title', type: 'text' },
  slides: {
    label: 'Slides',
    type: 'repeatable',
    fields: {
      'slide-image': {
        label: 'Slide image',
        type: 'media-manager',
        rules: ['required']
      },
      'slide-title': {
        label: 'Slide title',
        type: 'text',
        hideOnList: true
      },

      'slide-introtext': {
        label: 'Slide introtext',
        type: 'text-editor',
        hideOnList: true
      },
      'button-text': {
        label: 'Button text',
        type: 'text',
        hideOnList: true
      },
      'button-link': {
        label: 'Button link',
        type: 'text',
        hideOnList: true
      },
      'button-style': {
        label: 'Button style',
        type: 'radio',
        options: [
          { value: 'default', text: 'Default' },
          { value: 'outlined', text: 'Outlined' },
          { value: 'text', text: 'Plain text' }
        ],
        hideOnList: true
      },
      'button-background-color': {
        label: 'Button background color',
        type: 'background-color',
        hideOnList: true
      },
      'button-text-color': {
        label: 'Button text color for default style',
        type: 'text-color',
        hideOnList: true
      }
    }
  }
}

export const design = {
  'title-color': {
    label: 'Title color',
    type: 'text-color',
    category: 'Text'
  },
  'title-font-weight': {
    label: 'Title font weight',
    type: 'radio',
    options: [
      { value: 'var(--title-font-weight)', text: 'Default' },
      { value: 'lighter', text: 'Light' },
      { value: 'bold', text: 'Bold' }
    ],
    category: 'Text'
  },
  'title-tag': {
    label: 'Title header type',
    type: 'radio',
    options: [
      { value: 'h1', text: 'Heading 1' },
      { value: 'h2', text: 'Heading 2' },
      { value: 'h3', text: 'Heading 3' },
      { value: 'h4', text: 'Heading 4' },
      { value: 'h5', text: 'Heading 5' },
      { value: 'h6', text: 'Heading 6' }
    ],
    category: 'Text'
  },
  'introtext-color': {
    label: 'Introtext color',
    type: 'text-color',
    category: 'Text'
  }
}

export const layout = {
  'content-container-size': {
    label: 'Container size',
    type: 'radio',
    options: [
      { value: 'sm', text: 'Small' },
      { value: 'md', text: 'Medium' },
      { value: 'lg', text: 'Large' },
      { value: 'xl', text: 'Extra large' }
    ],
    category: 'Structure'
  },
  'content-horizontal-alignment': {
    label: 'Content horizontal alignment',
    type: 'radio',
    options: [
      { value: 'start', text: 'Left' },
      { value: 'center', text: 'Center' },
      { value: 'end', text: 'Right' }
    ],
    category: 'Structure'
  },
  ...contentBoxFormFields
}

export const advanced = {}

export default {
  content,
  design,
  layout,
  advanced
}
